/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ValidationIssueResponseCategory } from './validationIssueResponseCategory';
import type { ValidationIssueResponseCode } from './validationIssueResponseCode';
import type { ValidationIssueResponseMetadata } from './validationIssueResponseMetadata';
import type { ValidationIssueResponseSeverity } from './validationIssueResponseSeverity';

/**
 * Single validation issue surfaced in the preview UI.
 *
 * The recruiter sees a list of these per candidate in the
 * Fix-Issues / Warnings tab. ``message`` is the user-facing copy;
 * ``code`` is the stable machine identifier the frontend keys on.
 */
export interface ValidationIssueResponse {
  code: ValidationIssueResponseCode;
  severity: ValidationIssueResponseSeverity;
  category?: ValidationIssueResponseCategory;
  step_id?: string | null;
  variable_key?: string | null;
  message?: string | null;
  metadata?: ValidationIssueResponseMetadata;
}
